import { formatCurrency } from "../../../../../shared/utils/formatCurrency";
import styles from "../../styles/addInvoice.module.css";

export default function FilialDetailsSummary({ invoiceData }) {
  return (
    <div className={styles["filial-details-summary"]}>
      <div className={styles["filial-summary-relevant"]}>
        <h2>RESUMEN RÁPIDO</h2>
        <div className="d-flex justify-content-between align-items-center">
          <span>Fecha emisión</span>
          <span>{invoiceData.fecha_emision}</span>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <span>Fecha vencimiento</span>
          <span>{invoiceData.fecha_vencimiento}</span>
        </div>
      </div>
      <div className={styles["filial-summary-important"]}>
        <h2>Total a pagar</h2>
        <span>₡ {formatCurrency(invoiceData.monto)}</span>
      </div>
    </div>
  );
}
